export const studioAnnouncementTargets = [
  { value: "notifications", label: "Bildirimler" },
  { value: "wallet", label: "Paketlerim" },
  { value: "home", label: "Ana sayfa / Atölyeler" }
] as const;

export type StudioAnnouncementTarget = typeof studioAnnouncementTargets[number]["value"];

export interface StudioAnnouncementInput {
  title: string;
  message: string;
  targetScreen: StudioAnnouncementTarget;
}

export interface StudioAnnouncementResult {
  campaignId: string;
  recipientCount: number;
  replayed: boolean;
}

export function resolveStudioAnnouncementAttemptKey(
  currentKey: string | null,
  createKey: () => string = () => crypto.randomUUID()
) {
  return currentKey ?? createKey();
}

export function studioAnnouncementReviewRows(input: StudioAnnouncementInput) {
  const announcement = normalizeStudioAnnouncement(input);
  const targetLabel = studioAnnouncementTargets.find(
    (item) => item.value === announcement.targetScreen
  )?.label ?? announcement.targetScreen;

  return [
    { label: "Başlık", value: announcement.title },
    { label: "Mesaj", value: announcement.message },
    { label: "Açılacak ekran", value: targetLabel }
  ];
}

export function normalizeStudioAnnouncement(input: {
  title?: unknown;
  message?: unknown;
  targetScreen?: unknown;
}): StudioAnnouncementInput {
  const title = typeof input.title === "string" ? input.title.trim() : "";
  const message = typeof input.message === "string" ? input.message.trim() : "";
  const targetScreen = input.targetScreen;
  const targetAllowed = studioAnnouncementTargets.some((item) => item.value === targetScreen);

  if (!title || title.length > 100 || !message || message.length > 500 || !targetAllowed) {
    throw new Error("ANNOUNCEMENT_INVALID");
  }

  return {
    title,
    message,
    targetScreen: targetScreen as StudioAnnouncementTarget
  };
}

export function announcementErrorCopy(error: unknown) {
  const code = error instanceof Error ? error.message : "";
  if (code.includes("ANNOUNCEMENT_NO_RECIPIENTS")) {
    return "Stüdyo haberleri açık olan aktif bir mobil kullanıcı bulunamadı.";
  }
  if (code.includes("ANNOUNCEMENT_TARGET_INVALID")) {
    return "Duyurunun açacağı ekran geçerli değil.";
  }
  if (code.includes("ANNOUNCEMENT_TITLE_INVALID")) {
    return "Duyuru başlığı 1–100 karakter arasında olmalı.";
  }
  if (code.includes("ANNOUNCEMENT_MESSAGE_INVALID")) {
    return "Duyuru metni 1–500 karakter arasında olmalı.";
  }
  if (code.includes("ANNOUNCEMENT_AUDIENCE_CHANGED_RETRY")) {
    return "Alıcı listesi gönderim sırasında değişti. Bir kez daha deneyin.";
  }
  if (code.includes("ANNOUNCEMENT_IDEMPOTENCY_CONFLICT")) {
    return "Bu gönderim anahtarı başka bir duyuru için kullanılmış. İçeriği kontrol edip yeniden onaylayın.";
  }
  if (code.includes("ANNOUNCEMENT_INVALID")) {
    return "Başlık, mesaj ve açılacak ekran alanlarını kontrol edin.";
  }
  return "Mobil duyuru gönderilemedi. Bağlantıyı kontrol edip yeniden deneyin.";
}
